import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { Button, useTranslations } from "@jti/ui";
import { useCartMiniContext } from "../../../../contexts/CartMiniContext";
import styles from "./CartMiniCheckoutButton.module.scss";
export const CartMiniCheckoutButton = ({ isVisible, buyLimitation, onCheckoutClick, qtyPending, }) => {
    const { __ } = useTranslations();
    const { isDarkTheme } = useCartMiniContext();
    if (!isVisible) {
        return null;
    }
    const containerClasses = classNames(styles.checkoutButtonContainer, {
        [styles.dark]: isDarkTheme,
    });
    return (_jsx("div", { className: containerClasses, children: _jsx(Button, { color: "primary", className: styles.checkoutButton, disabled: buyLimitation || qtyPending, onClick: onCheckoutClick, "data-testid": "miniCartCheckoutButton", children: __("cart.cart_mini.button.checkout") }) }));
};
//# sourceMappingURL=CartMiniCheckoutButton.js.map